import api from "./axios";

const authHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getCountries = (token) => api.get("/countries", authHeaders(token));
export const getCountry = (id, token) => api.get(`/countries/${id}`, authHeaders(token));
export const createCountry = (data, token) => api.post("/countries", data, authHeaders(token));
export const updateCountry = (id, data, token) => api.put(`/countries/${id}`, data, authHeaders(token));
export const toggleCountry = (id, token) => api.put(`/countries/${id}/toggle`, {}, authHeaders(token));
export const getLanguagesByCountry = (countryId, token) => api.get(`/countries/${countryId}/languages`, authHeaders(token));
export const deleteCountries = (ids, token) => api.post(`/countries/delete`, { ids }, authHeaders(token));